/* RL ESTELLA ADV — conserva la query string de la URL (UTM, fbclid, gclid…) en todos los enlaces internos del advertorial
   (botón de la oferta e imagen enlazada → /products/ajo-negro-fermentado). Sin dependencias. */
(function () {
  function carry() {
    var qs = window.location.search;
    if (!qs || qs.length < 2) return;
    var cur = new URLSearchParams(qs);
    var links = document.querySelectorAll('.rle a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i], raw = a.getAttribute('href');
      if (!raw || raw.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(raw)) continue;
      var u;
      try { u = new URL(raw, window.location.href); } catch (e) { continue; }
      if (u.host !== window.location.host) continue;
      cur.forEach(function (v, k) { if (!u.searchParams.has(k)) u.searchParams.append(k, v); });
      a.setAttribute('href', u.pathname + u.search + u.hash);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', carry); else carry();
})();
